import { Flex, Heading } from '@chakra-ui/react'
import { FC } from 'react'

import AuthLayout from '@component/Layout/Auth'

const AuthError: FC = () => {
  return (
    <AuthLayout title="Erro interno.">
      <Flex alignItems="center" justifyContent="center" flexDir="column">
        <Heading mb={6} size="xs" color="gray.500" fontWeight="400">
          Ocorreu um erro durante a comunicação com os serviços do SCL.
        </Heading>
      </Flex>
    </AuthLayout>
  )
}

export default AuthError
